import "./DescriptiveLinkCard.scss";

import React from "react";

import { DescriptiveLinkCardData } from "design-system/shared/models/app-data-model";
import { getContentHubDamAsset } from "../../../../shared/utils/get-contenthub-dam-asset";
import PhLink from "design-system/shared/components/ph-link/ph-link";

export type DescriptiveLinkCardProps = {
  descriptiveLinkCard: DescriptiveLinkCardData;
};

const DescriptiveLinkCard: React.FC<DescriptiveLinkCardProps> = ({ descriptiveLinkCard }: DescriptiveLinkCardProps) => {
  return (
    <PhLink
      href={descriptiveLinkCard.reference[0]?.url || getContentHubDamAsset(descriptiveLinkCard.reference[0]?.contenthub_asset)?.url}
      className='descriptive-link-card'
    >
      <strong>{descriptiveLinkCard.page_title}</strong>
      <div className='description'>{descriptiveLinkCard.page_short_description}</div>
    </PhLink>
  );
};

export default DescriptiveLinkCard;
